/**
 * Guyanese dollar.
 */
export var GYD = {
  code: 'GYD',
  base: 10,
  exponent: 2
};